/********************************************************
 ** Home ALERTS
 ********************************************************/
/*
    Close function for the alerts banner.
*/
if (document.querySelector('.mod-alert')) {
	document.addEventListener("click", function (event) {
		let cookieData = getCookieValue('pm_dismissed_alerts');
		console.log(cookieData)
		let closeHomeAlert: HTMLElement = getParentElementWithClass(event.target, "js-alert-close");
		let theAlert: HTMLElement = getParentElementWithClass(event.target, "mod-alert");
		if (closeHomeAlert !== null && theAlert !== null) {
			let alertID = parseInt(theAlert.getAttribute("data-alertid"));
			let timestamp = (theAlert.dataset.timestamp) ? theAlert.dataset.timestamp : "";
			if (!isNaN(alertID) && alertID > -1) {
				var expires = new Date();
				expires.setDate(expires.getDate() + 30);

				const cookieArray: Array<String> = cookieData.split('|');
				for (let x=0; x < cookieArray.length; x++) {
					if (cookieArray[x].indexOf(alertID + ':') != -1) {
						cookieArray.splice(x,1);
					}
				}
				cookieData = cookieArray.join("|");

				setCookieValue('pm_dismissed_alerts', cookieData + "|" + alertID + ":" + timestamp, 30);
				vSlideUp(theAlert);
				setTimeout(function () {
					theAlert.classList.add("dismissed");
				}, 550);

				const alertBell = getParentElementWithClass(event.target, "alerts-container").querySelector(
					".alert-bell"
				);

				
				if (!alertBell.classList.contains('visible')) {
					vSlideDown(alertBell);
				}
				alertBell.classList.add('visible');
				
			}
		}
	});

	const alertBell: HTMLButtonElement = document.querySelector(".alert-bell");	
	const alerts: NodeListOf<HTMLElement> = alertBell.parentNode.querySelectorAll('.mod-alert');

	alerts.forEach(alert => {
		if (alert.classList.contains('dismissed')) {
			alertBell.style.display = "block"
		}
	})
	alertBell.querySelector('.js-alert-bell').addEventListener('click', () => {
		alerts.forEach(alert => {
			if (alert.classList.contains('dismissed')) {
				alert.classList.remove('dismissed');
				vSlideDown(alert);
			}
		})
		vSlideUp(alertBell);
		alertBell.classList.remove('visible');
	})

}
